var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.showText),expression:"showText"}],staticClass:"prompt",class:{
    'rounded-l left': _vm.position === 'left',
    'rounded-r right': _vm.position === 'right',
  }},[(_vm.position === 'left' && _vm.showAnswer && !_vm.hideConnect)?_c('div',{staticClass:"connect-line animate__animated animate__fadeInLeft",style:({
      'background-color': _vm.color,
    })}):_vm._e(),_c('div',{staticClass:"justify-center h-18 d-flex"},[(_vm.position === 'right')?_c('span',{staticClass:"items-center justify-center flex-shrink-0 font-bold rounded-l w-9 d-flex text-base-0 horizontal layout center",style:({
        'background-color': _vm.showAnswerColor ? _vm.color : '#B4BCCF',
      })},[_vm._v("\n      "+_vm._s(_vm.order)+"\n    ")]):_vm._e(),_c('div',{staticClass:"flex-grow border-t border-b horizontal layout center content",class:{
        'border-l rounded-l': _vm.position === 'left',
        'border-r rounded-r': _vm.position === 'right',
      },style:({
        'background-color': _vm.bgWithTextColor,
        'border-color': _vm.showAnswerColor || _vm.position === 'left' ? _vm.color : '#B4BCCF',
      })},[(_vm.image)?_c('span',{staticClass:"mr-2 w-12 min-w-12 image-wrapper"},[_c('div',{style:({
            'background-image': `url(${_vm.image})`,
            'background-position': '50% 50%',
            'background-size': 'cover',
            'background-repeat': 'no-repeat',
            'width': '48px',
            'height': '48px',
          })})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])]),(_vm.position === 'left')?_c('span',{staticClass:"items-center justify-center flex-shrink-0 font-bold rounded-r w-9 d-flex text-base-0 horizontal layout center",style:({
        'background-color': _vm.color,
      })},[_vm._v("\n      "+_vm._s(_vm.index)+"\n    ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }